import React from "react";

const IconLogoV2 = () => {
  return (
    <svg
      width="132"
      height="77"
      viewBox="0 0 132 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.1147 50.5927V26.4072H30.1079V50.5927H36.1147Z"
        fill="#1D99A9"
      />
      <path
        d="M58.0652 44.1814V41.8326H52.7259V44.0544C52.7259 45.7049 51.6135 46.784 49.3888 46.784C47.1641 46.784 46.0517 45.6414 46.0517 44.1179V32.8821C46.0517 31.2951 47.1641 30.216 49.3888 30.216C51.6135 30.216 52.7259 31.2951 52.7259 32.9456V35.1674H58.0652V32.8186C58.0652 28.8195 55.0989 25.7725 49.2405 25.7725C43.3079 25.7725 39.8967 29.0734 39.8967 33.263V43.737C39.8967 47.9266 43.3079 51.2275 49.2405 51.2275C55.0989 51.1641 58.0652 48.1805 58.0652 44.1814Z"
        fill="#1D99A9"
      />
      <path
        d="M79.4967 43.8005V33.1995C79.4967 28.9464 76.0854 25.8359 70.3012 25.8359C64.5169 25.8359 61.1057 28.9464 61.1057 33.1995V43.8005C61.1057 48.1171 64.5169 51.2275 70.3012 51.2275C76.0854 51.164 79.4967 48.1171 79.4967 43.8005ZM73.4158 44.0544C73.4158 45.7049 72.3034 46.784 70.3012 46.784C68.2989 46.784 67.1865 45.7049 67.1865 44.0544V32.8821C67.1865 31.2316 68.2989 30.1525 70.3012 30.1525C72.3034 30.1525 73.4158 31.2316 73.4158 32.8821V44.0544Z"
        fill="#1D99A9"
      />
      <path
        d="M101.892 50.5927V26.4072H96.4787V40.2456L94.1798 36.3099L88.1731 26.4072H83.2045V50.5927H88.6922V36.9447L91.0652 40.8804L97.2203 50.5927H101.892Z"
        fill="#1D99A9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.566 17.7106H23.4337C21.9506 17.7106 20.6899 18.7263 20.6899 20.0593V56.8772C20.6899 58.1467 21.8764 59.2259 23.4337 59.2259H108.566C110.049 59.2259 111.31 58.2102 111.31 56.8772V20.0593C111.236 18.7898 110.049 17.7106 108.566 17.7106ZM23.4337 13.0767C18.9101 13.0767 15.2764 16.1871 15.2764 20.0593V56.8772C15.2764 60.7494 18.9101 63.8598 23.4337 63.8598H108.566C113.09 63.8598 116.724 60.7494 116.724 56.8772V20.0593C116.724 16.1871 113.09 13.0767 108.566 13.0767H23.4337Z"
        fill="#1D99A9"
      />
      <path
        d="M125.919 20.6941C123.472 20.6941 121.47 19.1072 121.47 16.8854C121.47 14.6636 123.472 13.0767 125.919 13.0767C128.366 13.0767 130.369 14.6636 130.369 16.8854C130.369 19.1072 128.366 20.6941 125.919 20.6941ZM125.919 13.521C123.769 13.521 122.063 14.9176 122.063 16.8854C122.063 18.7898 123.769 20.2498 125.919 20.2498C128.07 20.2498 129.775 18.8532 129.775 16.8854C129.775 14.981 128.07 13.521 125.919 13.521ZM127.18 18.7263L125.771 17.1393H124.807V18.7263H124.213V14.8541H126.067C127.106 14.8541 127.625 15.2984 127.625 15.9967C127.625 16.695 126.883 17.0124 126.364 17.0758L127.773 18.7263H127.18ZM126.067 15.2984H124.881V16.695H126.067C126.735 16.695 127.106 16.441 127.106 15.9967C127.106 15.5523 126.735 15.2984 126.067 15.2984Z"
        fill="#1D99A9"
      />
    </svg>
  );
};

export default IconLogoV2;
